import { api } from "./client";

export interface BudgetStatus {
  withinBudget: boolean;
  unlimited: boolean;
  budgetCents: number;
  spentCents: number;
  utilizationPercent: number;
}

export const budgetApi = {
  /** GET /api/companies/:companyId/budget */
  get: (companyId: string) =>
    api.get<BudgetStatus>(`/companies/${encodeURIComponent(companyId)}/budget`),

  /** PUT /api/companies/:companyId/budget — set the monthly budget (cents; 0 = unlimited) */
  set: (companyId: string, budgetCents: number) =>
    api.put<BudgetStatus>(`/companies/${encodeURIComponent(companyId)}/budget`, { budgetCents }),
};
